import React from "react";

const MiniCard = ({ children }) => {
  return (
    <div
      style={{
        width: "130px",
        padding: "1px 2px",
        background: "#eeeeee",
        // border: "solid 1px",
        fontSize:"12px",
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        borderRadius:"5px",
        marginRight:"1px",
        marginTop:"4px"
      }}
    >
      {children}
    </div>
  );
};

export default MiniCard;
